import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'next-i18next'
import './Header.scss'

const Header = () => {
  const { t, i18n } = useTranslation()

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es'
    i18n.changeLanguage(newLang)
  }

  return (
    <header className="header">
      <div className="container center">
        <div className="header-content center">
          <Link to="/" className="logo">
            <img src="/logo.webp" alt="PianoMeetups" className="logo-icon" />
          </Link>
          
          <nav className="nav">
            <button 
              className="language-toggle"
              onClick={toggleLanguage}
              aria-label={t('header.changeLanguage', 'Change language')}
            >
              {i18n.language === 'es' ? 'EN' : 'ES'}
            </button>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header